import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GOOGLE_ADS_ID = "AW-18529193654";

export default function GoogleAdsPageviews() {
  const location = useLocation();
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      send_to: GOOGLE_ADS_ID,
      page_title: document.title,
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}${location.hash}`,
    });
  }, [location]);

  return null;
}
